<div *ngIf="!internetConnectedFlag" class="no-internet">
  {{ "errorMessages.no_internet_connection" | translate }}
</div>
